import angular from 'angular';
import jsData from 'js-data-angular';
import { RadniNalog } from './radniNalog.js';
import { PlanRada } from './radniNalog.js';
import { Ordinacija } from './ordinacija.js';
import { Tehnicar } from './tehnicar.js';
import { Valuta } from './valuta.js';
import { PoreznaStopa } from './poreznaStopa.js';
import { ProtetskiRad } from './protetskiRad.js';
import { Cjenik } from './cjenik.js';
import { StavkaCjenika } from './stavkaCjenika.js';
import { Boja } from './boja.js';
import { OznakaBoje } from './oznakaBoje.js';
import { FazaNaloga } from './fazaNaloga.js';
import { StavkaNaloga } from './stavkaNaloga.js';
import { KorisnikOrdinacija } from './korisnikOrdinacija.js';
import { Materijal } from './materijal.js';
import { GrupaRada } from './grupaRada.js';
import { VrstaRada } from './vrstaRada.js';
import { DokumentNaloga } from './dokumentNaloga.js';
import { Token } from './tokens.js';
import { Komentar, NeprocitanKomentar } from './komentar.js';

import { meta } from './meta.js';

const models = angular.module('models', [jsData]);

Config.$inject = ['DSProvider', 'DSHttpAdapterProvider', '$httpProvider'];
function Config(DSProvider, DSHttpAdapterProvider, $httpProvider) {
    angular.extend(DSProvider.defaults, {
        bypassCache: false,
        cacheResponse: true,
        deserialize: function(resourceName, res) {
            if (angular.isDefined(res.data) && angular.isDefined(res.data.results)) {
                var newResponse = res.data.results;
                newResponse.meta = {
                    count: res.data.count,
                    next: res.data.next,
                    previous: res.data.previous,
                    start: res.data.start,
                    end: res.data.end
                };
                meta[resourceName.name] = newResponse.meta;
                return newResponse;
            }
            return res.data;
        }
    });
    angular.extend(DSHttpAdapterProvider.defaults, {
        basePath: '/api/radni_nalozi'
    });

    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
}

models.run([
    'DS',
    'RadniNalog',
    'Ordinacija',
    'Tehnicar',
    'Valuta',
    'PoreznaStopa',
    'ProtetskiRad',
    'Cjenik',
    'StavkaCjenika',
    'Boja',
    'OznakaBoje',
    'FazaNaloga',
    'StavkaNaloga',
    'KorisnikOrdinacija',
    'Materijal',
    'GrupaRada',
    'VrstaRada',
    'DokumentNaloga',
    'PlanRada',
    'Token',
    'Komentar',
    'NeprocitanKomentar',
    function() {
        // require('./factory.js')(DS);
    }
]);

models.config(Config);

models.factory('RadniNalog', RadniNalog);
models.factory('Ordinacija', Ordinacija);
models.factory('Tehnicar', Tehnicar);
models.factory('Valuta', Valuta);
models.factory('PoreznaStopa', PoreznaStopa);
models.factory('ProtetskiRad', ProtetskiRad);
models.factory('Cjenik', Cjenik);
models.factory('StavkaCjenika', StavkaCjenika);
models.factory('Boja', Boja);
models.factory('OznakaBoje', OznakaBoje);
models.factory('FazaNaloga', FazaNaloga);
models.factory('StavkaNaloga', StavkaNaloga);
models.factory('KorisnikOrdinacija', KorisnikOrdinacija);
models.factory('Materijal', Materijal);
models.factory('GrupaRada', GrupaRada);
models.factory('VrstaRada', VrstaRada);
models.factory('DokumentNaloga', DokumentNaloga);
models.factory('PlanRada', PlanRada);
models.factory('Token', Token);
models.factory('Komentar', Komentar);
models.factory('NeprocitanKomentar', NeprocitanKomentar);

export { models };



// WEBPACK FOOTER //
// ./app/models/models.js